import * as React from "react";

function SvgLoadPort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M0 5v3h22V5H0zM4 16l7-7 7 7h-5v6H9v-6H4zM1 4h20l-4-4H5L1 4z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLoadPort;
